export const getEntities = state => state.entities;
